<div [id]="card.id"
     class="flex surface-card flex-column w-full border-1 surface-border p-3 gap-3 hover:surface-ground cursor-pointer border-round h-12rem"
     (click)="openDetails()">
    <div class="flex align-items-center justify-content-between">
        <app-task-status-icon [status]="returnStatus()"></app-task-status-icon>
        <span class="text-900 font-semibold">{{ card.targetDate }}</span>
        <!--        <div>-->
        <!--            <button pButton pRipple type="button" icon="pi pi-ellipsis-v" class="p-button-rounded p-button-text p-button-secondary p-trigger" (click)="menu.toggle($event)"></button>-->
        <!--            <p-tieredMenu #menu [model]="menuItems" appendTo="body" [popup]="true"></p-tieredMenu>-->
        <!--        </div>-->
        <div>
            <i [ngClass]="returnPriority()" class="text-black-alpha-90"></i>
        </div>
    </div>
    <div class="flex align-items-center">
        <span class="text-900 font-semibold">{{ card.no }} {{ card.title ? card.title : 'Untitled' }}</span>
    </div>
    <div *ngIf="card.description" style="word-break: break-word" class="text-700">
        <span class="line-breaks-in-2nd-line">
        {{ card.description }} Lorem ipsum dolor sit amet, consectetur adipisicing elit. Alias aperiam consequuntur debitis eius explicabo, fugiat in inventore laborum nesciunt nostrum optio ratione sed tempore veniam vitae, voluptate voluptatem voluptates, voluptatum.
        </span>
    </div>
    <div class="pt-4 font-semibold">
        {{ card.recipient }}
    </div>
</div>
